import { render, staticRenderFns } from "./StakeholderModal.vue?vue&type=template&id=00fabf20"
import script from "./StakeholderModal.vue?vue&type=script&lang=js"
export * from "./StakeholderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fabf20')) {
      api.createRecord('00fabf20', component.options)
    } else {
      api.reload('00fabf20', component.options)
    }
    module.hot.accept("./StakeholderModal.vue?vue&type=template&id=00fabf20", function () {
      api.rerender('00fabf20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/StakeholderModal.vue"
export default component.exports